import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

const SearchFacets = React.lazy(() => import('../SearchFacets'));

const MobileFilterDialog = ({ open, onClose, facets, searchParameters, fieldConfig, onChange }) => {
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  const [newValues, setNewValues] = React.useState([]);
  React.useEffect(() => {
    if (open) {
      setNewValues([]);
    }
  }, [open]);

  const newParams = { ...searchParameters };
  for (const p of newValues) {
    newParams[p.slug] = p.newValue;
  }

  return (<Dialog
    fullScreen
    open={open}
    onClose={onClose}
    scroll={'paper'}
  >
    <DialogTitle id="scroll-dialog-title">Filter Results</DialogTitle>
    <DialogContent dividers={true}>
      <DialogContentText
        id="scroll-dialog-description"
        ref={descriptionElementRef}
        tabIndex={-1}
        component={'div'}
      >
        <React.Suspense fallback={null}>
          <SearchFacets
            facets={facets}
            searchParameters={newParams}
            fieldConfig={fieldConfig}
            onChange={({ slug, ...rest }) => setNewValues([
              ...newValues.filter(({ slug: s }) => s !== slug),
              { slug, ...rest }
            ])}
          />
        </React.Suspense>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        sx={{ flexGrow: 1 }} color="secondary" fullWidth variant={'contained'} onClick={onClose}>Cancel</Button>
      <Button
        sx={{ flexGrow: 1 }}
        color="primary" fullWidth variant={'contained'} onClick={() => {
          onChange(newValues);
          onClose();
        }}>Save</Button>
    </DialogActions>
  </Dialog>
  );
};

MobileFilterDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  searchParameters: PropTypes.shape({}).isRequired,
  facets: PropTypes.shape({}).isRequired,
  fieldConfig: PropTypes.arrayOf(PropTypes.shape({
    'details_open': PropTypes.bool,
    'details_show': PropTypes.bool,
    'icon': PropTypes.node,
    'name': PropTypes.node.isRequired,
    'search_open': PropTypes.bool,
    'search_show': PropTypes.bool,
    'values': PropTypes.arrayOf(PropTypes.shape({
      'category': PropTypes.node,
      'details_show': PropTypes.bool,
      'name': PropTypes.node,
      'reverse': PropTypes.bool,
      'search_show': PropTypes.bool,
      'slug': PropTypes.string.isRequired,
      'type': PropTypes.string.isRequired
    }))
  }))
};

MobileFilterDialog.defaultProps = {
  showFilters: false,
  onClose: () => {
  },
  onChange: () => {
  }
};

export default MobileFilterDialog;
export { MobileFilterDialog };